import { render, staticRenderFns } from "./AssetProfileTable.vue?vue&type=template&id=2a04e91c&scoped=true&"
import script from "./AssetProfileTable.vue?vue&type=script&lang=js&"
export * from "./AssetProfileTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetProfileTable.vue?vue&type=style&index=0&id=2a04e91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04e91c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
